import React, { useEffect, useState } from 'react';
import { getCookie, setCookie } from '../utils/cookies';

const CONSENT_CLOSED_COOKIE = 'cookie_consent_closed';
const CONSENT_CHOICE_COOKIE = 'cookie_consent_choice';
const CONSENT_TTL_DAYS = 180;

const CookieConsentBox: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isClosed = getCookie(CONSENT_CLOSED_COOKIE) === '1';
    setIsVisible(!isClosed);
  }, []);

  const closeWithChoice = (choice: 'necessary' | 'all') => {
    setCookie(CONSENT_CHOICE_COOKIE, choice, CONSENT_TTL_DAYS);
    setCookie(CONSENT_CLOSED_COOKIE, '1', CONSENT_TTL_DAYS);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 z-[70] sm:right-auto sm:max-w-[420px]"
      role="dialog"
      aria-live="polite"
      aria-label="Informacja o cookies"
    >
      <div className="rounded-2xl border border-white/15 bg-[#1d2238]/90 p-5 shadow-[0_12px_40px_rgba(0,0,0,0.45)] backdrop-blur-md">
        <div className="mb-3 flex justify-center">
          <span
            aria-hidden
            className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/10 text-base"
          >
            🍪
          </span>
        </div>

        <p className="text-center text-[15px] leading-relaxed text-gray-100">
          Uzywamy plikow cookies, aby zapewnic bezpieczne dzialanie serwisu. Za Twoja zgoda uruchamiamy takze analityke i reklamy.
        </p>

        <p className="mt-3 text-xs leading-relaxed text-gray-300">
          Korzystanie z cookies opisujemy szczegolowo w dokumentach:
          {' '}
          <a
            href="/sekcja-prawna?sekcja=regulamin-serwisu"
            className="text-mystic-accent underline underline-offset-2 hover:text-mystic-accentHover"
          >
            Regulamin serwisu
          </a>
          ,{' '}
          <a
            href="/sekcja-prawna?sekcja=polityka-prywatnosci"
            className="text-mystic-accent underline underline-offset-2 hover:text-mystic-accentHover"
          >
            Polityka prywatnosci i RODO
          </a>
          {' '}oraz{' '}
          <a
            href="/sekcja-prawna?sekcja=informacja-cookies-analityka"
            className="text-mystic-accent underline underline-offset-2 hover:text-mystic-accentHover"
          >
            Informacja o cookies i analityce
          </a>
          .
        </p>

        <div className="mt-4 flex flex-row gap-2 sm:justify-center">
          <button
            type="button"
            onClick={() => closeWithChoice('necessary')}
            className="inline-flex w-1/2 items-center justify-center rounded-[22px] rounded-br-[5px] rounded-tr-[5px] border border-white/35 bg-white/5 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:w-auto sm:min-w-[170px]"
          >
            Zaakceptuj niezbedne
          </button>
          <button
            type="button"
            onClick={() => closeWithChoice('all')}
            className="inline-flex w-1/2 items-center justify-center rounded-[22px] rounded-bl-[5px] rounded-tl-[5px] border border-mystic-accent/80 bg-mystic-accent px-4 py-2.5 text-sm font-semibold text-black transition hover:bg-mystic-accentHover sm:w-auto sm:min-w-[170px]"
          >
            Zaakceptuj wszystkie
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBox;
